
import { observable, action, makeObservable } from 'mobx';
import UserStore from './user-store';
import BookingStore from './booking-store';
import ClinicStore from './clinic-store';
import PackageStore from './package-store';
import PatientStore from './patient-store';
import OptionStore from './option-store';
import EventStore from './event-store';

interface WebNotification {
  message: string;
  options?: {
    variant: "success" | "error" | "info" | "warning";
  };
}

export default class RootStore {
  testVal = "TEST_VALUE";

  destination = "Select";

  notification: WebNotification = {
    message: "",
    options: {
      variant: "info",
    },
  };

  userStore;
  bookingStore;
  clinicStore;
  packageStore;
  patientStore;
  optionStore;
  eventStore;

  constructor() {
    makeObservable(this, {
      testVal: observable,
      destination: observable,
      notification: observable,
      notify: action,
    });
    this.userStore = new UserStore(this);
    this.bookingStore = new BookingStore(this);
    this.clinicStore = new ClinicStore(this);
    this.packageStore = new PackageStore(this);
    this.patientStore = new PatientStore(this);
    this.optionStore = new OptionStore(this);
    this.eventStore = new EventStore(this);
  }

  notify(msg: string, level?: "success" | "error" | "info" | "warning") {
    if (level) {
      this.notification = {
        message: msg,
        options: {
          variant: level,
        },
      };
    } else {
      this.notification = {
        message: msg,
      };
    }
  }
}
